/* eslint-disable max-len */

import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToCreateTaskSteps = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;

  const createTaskSteps: StepType[] = [
    {
      content: 'Go to the Sales menu tab.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.MENU}"]`,
      position: 'right',
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 200);
          },
          false,
        );
      },
      disableActions: true,
      styles: {
        arrow: (base) => ({
          ...base,
          visibility: 'hidden',
        }),
      },
    },
    {
      content: 'Then select Task to view the Task page.',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 200);
          },
          false,
        );
      },
      disableActions: false,
      styles: {
        arrow: (base) => ({
          ...base,
        }),
      },
    },
    {
      content: 'Click the Create Task button.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.FORM.CREATE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 400);
            // setIsOpen(false);
          },
          false,
        );
      },
      position: 'bottom',
    },
    {
      content: (props) => (
        <Content
          {...props}
          content={
            'Enter the task details, including the title, due date, task type, priority level, associated contact, task assignment to a specific team member, and description. You may also upload file attachments for your task.'
          }
          type="create task"
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.FORM.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="Modal__Header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.FORM.FORM}"]`,
      ],
      disableActions: false,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(4), 100);
          },
          false,
        );
      },
      stepInteraction: false,
      position: 'right',
    },
    {
      content: 'Click Create Task to confirm and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.FORM.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
    },
  ];

  const showCreateTaskSteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(createTaskSteps);
      setIsOpen(true);
    }, 300);
  };

  return showCreateTaskSteps;
};

export default useGetHowToCreateTaskSteps;
